import { render, staticRenderFns } from "./reccost.vue?vue&type=template&id=77b476e6&scoped=true&"
import script from "./reccost.vue?vue&type=script&lang=js&"
export * from "./reccost.vue?vue&type=script&lang=js&"
import style0 from "./reccost.vue?vue&type=style&index=0&id=77b476e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b476e6",
  null
  
)

export default component.exports